/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import router, { blankRoutes, constantRoutes } from "@/router";
import store from "@/store";
import { platform } from "@/config/edition.config";
import { routesWhiteList } from "@/config/net.config";
import { Notification } from "element-ui";
import XEUtils from "xe-utils/ctor";

router.beforeEach(async (to, from, next) => {
  let hasToken = store.getters.token;
  if (hasToken) {
    if (store.getters.routes[0]) {
      // 禁止已登录用户返回登录页
      if (to.path === "/login") {
        next({ path: "/" });
        // if (showProgressBar) VabProgress.done();
      } else if (["/rP/reset", "/callback"].includes(to.path)) {
        next();
      } else {
        if (localStorage.getItem("post")) {
          const post = JSON.parse(localStorage.getItem("post"));
          if (post.postId !== store.getters.currentRole.postId) {
            await store.dispatch("changeRole", post);
            await store.dispatch("setRoutes");
          }
        }
        /*else {
          await store.dispatch("getUserInfo");
          await store.dispatch("setRoutes");
        }*/
        const routes = store.getters.routes.filter((x) =>
          [...constantRoutes, ...blankRoutes].every((y) => y.name !== x.name)
        );
        if (routes[0]) {
          if (
            XEUtils.findTree(
              store.getters.routes,
              (item) => item.name === to.name
            )
          ) {
            next();
          } else {
            next({ path: routes[0].redirect, replace: true });
          }
        } else {
          if (localStorage.getItem("post")) {
            Notification.error({
              title: "错误",
              message: "当前岗位不存在权限！",
            });
          } else {
            Notification.error({
              title: "错误",
              message: "当前账号不存在岗位或当前岗位不存在权限！",
            });
          }
          await store.dispatch("resetAll");
          next({ path: "/login", replace: true });
        }
      }
    } else {
      try {
        // 防止跳转修改密码时无路由数据
        await store.dispatch("setRoutes");

        await store.dispatch("getUserInfo");
        if (store.getters.userInfo.xm) {
          if (localStorage.getItem("post")) {
            const post = JSON.parse(localStorage.getItem("post"));
            if (post.postId !== store.getters.currentRole.postId)
              await store.dispatch("changeRole", post);
          }
          // 根据路由模式获取路由并根据权限过滤
          await store.dispatch("setRoutes");
          // await router.push({...to, replace: true});
          next({ ...to, replace: true });
        }
      } catch (err) {
        await store.dispatch("resetAll");
        next({ path: "/login", replace: true });
      }
    }
  } else {
    if (routesWhiteList.includes(to.path)) {
      next();
    } else next({ path: "/login", replace: true });
  }
});
router.afterEach((to) => {
  let title = platform.title;
  if (to.meta && to.meta.title) title += " - " + to.meta.title;
  document.title = title;
  // if (VabProgress.status) VabProgress.done();
});
